export default "__VITE_ASSET__BJBbunfz__"